import { render, staticRenderFns } from "./prepareKeepInfo.vue?vue&type=template&id=87791740&scoped=true&"
import script from "./prepareKeepInfo.vue?vue&type=script&lang=js&"
export * from "./prepareKeepInfo.vue?vue&type=script&lang=js&"
import style0 from "./prepareKeepInfo.vue?vue&type=style&index=0&id=87791740&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87791740",
  null
  
)

export default component.exports